import { render } from "./AuthShell.vue?vue&type=template&id=0df9b4dc&scoped=true"
import script from "./AuthShell.vue?vue&type=script&lang=js"
export * from "./AuthShell.vue?vue&type=script&lang=js"

import "./AuthShell.vue?vue&type=style&index=0&id=0df9b4dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0df9b4dc"]])

export default __exports__